import React from 'react';

const LINKS = [
  { href: '/legal/privacy', label: 'Privacy' },
  { href: '/legal/terms', label: 'Terms' },
  { href: '/legal/data-disclosure', label: 'Data disclosure' },
  { href: '/legal/compliance', label: 'Compliance' },
  { href: '/legal/ip', label: 'IP' },
];

function assignToPath(e, path) {
  if (typeof window === 'undefined') return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (e.button !== 0) return;
  e.preventDefault();
  e.stopPropagation();
  if (!path.startsWith('/')) return;
  window.location.assign(`${window.location.origin}${path}`);
}

/**
 * Compact legal links — use on login, platform overview, and authenticated shell footer.
 * Uses <a href> for semantics + middle-click, and onClick + location.assign so navigation is not
 * swallowed by overlays or 401 handlers racing SPA routing on pilot hosts.
 */
export function LegalFooter({ className = '' }) {
  return (
    <footer className={`relative z-[100] text-center ${className}`}>
      <nav
        className="pointer-events-auto flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground"
        aria-label="Legal"
      >
        <a
          href="/legal"
          className="relative z-10 cursor-pointer hover:text-primary hover:underline"
          onClick={(e) => assignToPath(e, '/legal')}
        >
          Legal hub
        </a>
        <span className="text-border" aria-hidden>
          ·
        </span>
        {LINKS.map((l, i) => (
          <React.Fragment key={l.href}>
            {i > 0 ? (
              <span className="text-border" aria-hidden>
                ·
              </span>
            ) : null}
            <a
              href={l.href}
              className="relative z-10 cursor-pointer hover:text-primary hover:underline"
              onClick={(e) => assignToPath(e, l.href)}
            >
              {l.label}
            </a>
          </React.Fragment>
        ))}
      </nav>
    </footer>
  );
}
